// extracted by mini-css-extract-plugin
export default {"draggable":"sortable-content_draggable__r8dD9","handle":"sortable-content_handle__FPRrD","grip":"sortable-content_grip__tfqCi"};